module.exports = __webpack_public_path__ + "img/spring-repair-service.6368071a.jpg";